import { render, staticRenderFns } from "./Termsofuse.vue?vue&type=template&id=418dbcfa&"
import script from "./Termsofuse.vue?vue&type=script&lang=js&"
export * from "./Termsofuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports